<template>
  <div class="oneStop">
    <PhoneBox />
    <div class="clientInfo">
      <ClientBox :select="3" :background="'#E6E6E6'">
        <div class="search">
          <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          Search
        </div>

        <div class="charts">
          <p>Analytics</p>
          <div class="sale">
            <div>
              <p>Gross volume</p>
              <img src="@/assets/images/Client/chart1.png">
            </div>
            <div>
              <p>Top sales products</p>
              <img src="@/assets/images/Client/chart2.png">
            </div>
          </div>

          <div class="activity">
            <div class="title">
              <span>Risk activity</span>
              <div>
                <div></div>
                <span>Blocker payments</span>
                <div></div>
                <span>Allowed payments</span>
              </div>
            </div>

            <img src="@/assets/images/Client/chart3.png">
          </div>
        </div>
      </ClientBox>
    </div>

  </div>
</template>

<script>
  import ClientBox from '../ClientBox';
  import PhoneBox from '../PhoneShopAni'
  // import tween from "@tweenjs/tween.js";
  export default {
    name: "index",
    components: {
      ClientBox,
      PhoneBox,
    },
    data() {
      return {
        timeOutList : [],
        showPayInfo: false,
      }
    },
    mounted() {

    },

    methods: {

    },
  }
</script>

<style lang="less" scoped>
.oneStop {
  display: flex;

  .clientInfo {
    margin-left: 110px;
    margin-top: 60px;
    transform: scale(1.2);
    .box {
      box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32), 0px -3px 8px 0px rgba(149, 161, 173, 0.75) inset;
    }
    .search {
      background: #FFFFFF;
      border-radius: 12px;
      color: #425466;
      font-size: 12px;
      line-height: 18px;
      padding: 2px;
      & > svg {
        width: 10px;
        margin: 1px 5px 0 6px;
      }
    }

    .charts {
      padding: 15px;
      background: #FFFFFF;
      border-radius: 8px;
      margin-top: 10px;
      & > p {
        font-size: 14px;
        font-weight: 500;
        color: #4A5A6D;
        line-height: 17px;
      }

      .sale {
        display: flex;
        justify-content: space-between;
        margin-top: 15px;
        & > div {
          & > p {
            font-size: 10px;
            font-weight: 500;
            color: #4A5A6D;
            line-height: 12px;
            margin-bottom: 9px;
          }
          & > img{
            height: 123px;
          }
        }
      }

      .activity {
        margin-top: 20px;
        .title {
          display: flex;
          justify-content: space-between;
          margin-bottom: 9px;
          & > span {
            font-size: 12px;
            line-height: 16px;
            color: #4A5A6D;
          }
          & > div {
            display: flex;
            align-items: center;
            & > div {
              width: 15px;
              height: 4px;
              background: linear-gradient(90deg,#2334AE 0%, #82AFFF 100%);
              border-radius: 8px;
              margin-left: 5px;
              &:first-child {
                background: linear-gradient(90deg,#3023AE 0%, #ED82FF 100%);
              }
            }
            & > span {
              font-size: 10px;
              color: #63798C;
              line-height: 12px;
              margin-left: 5px;
            }
          }
        }
        & > img {
          width: 435px;
        }
      }
    }
  }
}
</style>
